import { ICreateDishState } from './createDishContext';
import { CreateDishActionTypes, TCreateDishAction } from './createDishActions';

export const createDishReducer = (state: ICreateDishState, action: TCreateDishAction): ICreateDishState => {
	switch (action.type) {
		case CreateDishActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateDishActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case CreateDishActionTypes.CHANGE_DISH_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateDishActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case CreateDishActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.customer,
				fetchedRestaurants: [],
				restaurantsForPrice: [],
				totalPrices: [],
				restaurantWithTurnOffComment: [],
				restaurantWithRequiredComment: [],
				isDisabledInRestaurants: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
				fetchedDishModifications: [],
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
			};
		case CreateDishActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case CreateDishActionTypes.SET_RESTAURANTS_FOR_PRICE:
			return {
				...state,
				restaurantsForPrice: action.payload.restaurants,
			};
		case CreateDishActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case CreateDishActionTypes.ADD_PRICE:
			return {
				...state,
				totalPrices: [...state.totalPrices, ...action.payload.prices],
				price: '',
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
				fetchedDishModifications: [],
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
			};
		case CreateDishActionTypes.REMOVE_PRICE:
			return {
				...state,
				totalPrices: action.payload.updatedTotalPrices,
				restaurantsForPrice: action.payload.updatedRestaurantsForPrices,
				isDisabledInRestaurants: action.payload.updatedIsDisabledInRestaurants,
				restaurantWithTurnOffComment: action.payload.restaurantWithTurnOffComment,
				restaurantWithRequiredComment: action.payload.restaurantWithRequiredComment,
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
				fetchedDishModifications: [],
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
			};
		case CreateDishActionTypes.CHANGE_DISH_DESCRIPTION:
			return {
				...state,
				shortDescription: action.payload.shortDescription,
			};
		case CreateDishActionTypes.SET_RESTAURANT_WITH_TURN_OFF_COMMENT:
			return {
				...state,
				restaurantWithTurnOffComment: action.payload.restaurantWithTurnOffComment,
			};
		case CreateDishActionTypes.SET_RESTAURANT_WITH_REQUIRED_COMMENT:
			return {
				...state,
				restaurantWithRequiredComment: action.payload.restaurantWithRequiredComment,
			};
		case CreateDishActionTypes.SET_DISH_IS_DISABLED:
			return {
				...state,
				isDisabledInRestaurants: action.payload.restaurants,
			};
		case CreateDishActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateDishActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateDishActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateDishActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case CreateDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case CreateDishActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.categories,
			};
		case CreateDishActionTypes.SET_SUGGESTED_DISH_CATEGORY:
			return {
				...state,
				selectedSuggestedDishCategory: action.payload.suggestedDishCategory,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
			};
		case CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedSuggestedDishSubCategories: action.payload.suggestedDishSubCategories,
			};
		case CreateDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedSuggestedDishSubCategory: action.payload.suggestedDishSubCategory,
			};
		case CreateDishActionTypes.SET_FETCHED_SUGGESTED_DISHES:
			return {
				...state,
				fetchedSuggestedDishes: action.payload.suggestedDishes,
			};
		case CreateDishActionTypes.SET_SUGGESTED_DISHES:
			return {
				...state,
				selectedSuggestedDishes: action.payload.suggestedDishes,
			};
		case CreateDishActionTypes.REMOVE_SUGGESTED_DISH:
			return {
				...state,
				selectedSuggestedDishes: action.payload.updatedSelectedSuggestedDishes,
			};
		case CreateDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY:
			return {
				...state,
				selectedAdditionalDishCategory: action.payload.additionalDishCategory,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
			};
		case CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedAdditionalDishSubCategories: action.payload.additionalDishSubCategories,
			};
		case CreateDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedAdditionalDishSubCategory: action.payload.additionalDishSubCategory,
			};
		case CreateDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES:
			return {
				...state,
				fetchedAdditionalDishes: action.payload.additionalDishes,
			};
		case CreateDishActionTypes.SET_ADDITIONAL_DISHES:
			return {
				...state,
				selectedAdditionalDishes: action.payload.additionalDishes,
			};
		case CreateDishActionTypes.REMOVE_ADDITIONAL_DISH:
			return {
				...state,
				selectedAdditionalDishes: action.payload.updatedSelectedAdditionalDishes,
			};
		case CreateDishActionTypes.SET_DISH_MODIFICATION_CATEGORY:
			return {
				...state,
				selectedDishModificationCategory: action.payload.dishModificationCategory,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
			};
		case CreateDishActionTypes.SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES:
			return {
				...state,
				fetchedDishModificationSubCategories: action.payload.dishModificationSubCategories,
			};
		case CreateDishActionTypes.SET_DISH_MODIFICATION_SUB_CATEGORY:
			return {
				...state,
				selectedDishModificationSubCategory: action.payload.dishModificationSubCategory,
			};
		case CreateDishActionTypes.SET_FETCHED_DISH_MODIFICATIONS:
			return {
				...state,
				fetchedDishModifications: action.payload.dishModifications,
			};
		case CreateDishActionTypes.SET_DISH_MODIFICATIONS:
			return {
				...state,
				selectedDishModifications: action.payload.dishModifications,
			};
		case CreateDishActionTypes.REMOVE_DISH_MODIFICATION:
			return {
				...state,
				selectedDishModifications: action.payload.updatedSelectedDishModifications,
				IDsShowInComboDishes: action.payload.IDsShowInComboDishes,
			};
		case CreateDishActionTypes.SET_IDS_SHOW_IN_COMBO_DISHES:
			return {
				...state,
				IDsShowInComboDishes: action.payload.IDsShowInComboDishes,
			};
		case CreateDishActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case CreateDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateDishActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateDishActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				name: '',
				fetchedCustomers: [],
				selectedCustomer: null,
				fetchedRestaurants: [],
				restaurantsForPrice: [],
				price: '',
				totalPrices: [],
				restaurantWithTurnOffComment: [],
				restaurantWithRequiredComment: [],
				shortDescription: '',
				isDisabledInRestaurants: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				activationSchedule: '',
				deactivationSchedule: '',
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
				fetchedDishModifications: [],
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
				externalId: null,
				typeOfModalWindow: null,
				errorResponseData: null,
			};
		default:
			return state;
	}
};
